import styled from "styled-components";

export const DoughnutWrapper = styled.div`
  width: 100%;

  .chart-title {
    font-size: 1.2rem;
    font-weight: 700;
    color: ${({theme}) => theme.text.prim_200};
    margin-bottom: 1rem;

  }
`